import React from 'react';
import { FaHome } from 'react-icons/fa';

const AdminLayout = ({ children, title, breadcrumbs = [] }) => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 sticky top-0 z-10 shadow-sm">
                <div className="max-w-7xl mx-auto px-6 py-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <button 
                                onClick={() => window.location.href = '/admin'}
                                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                                title="Back to dashboard"
                            >
                                <FaHome className="text-gray-600" />
                            </button>
                            <div className="flex items-center gap-2 text-sm">
                                <span 
                                    className="text-blue-600 hover:text-blue-700 cursor-pointer font-medium"
                                    onClick={() => window.location.href = '/admin'}
                                >
                                    Administration
                                </span>
                                {breadcrumbs.map((crumb, index) => (
                                    <React.Fragment key={index}>
                                        <span className="text-gray-400">/</span>
                                        <span 
                                            className={`${crumb.href ? 'text-blue-600 hover:text-blue-700 cursor-pointer' : 'text-gray-900'} font-medium`}
                                            onClick={() => crumb.href && (window.location.href = crumb.href)}
                                        >
                                            {crumb.label}
                                        </span>
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="max-w-7xl mx-auto px-6 py-8">
                <div className="bg-white rounded-2xl shadow-md">
                    {title && (
                        <div className="px-6 py-5 border-b border-gray-200">
                            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
                        </div>
                    )}
                    <div className="p-6">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLayout;
